import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

import BaseController from '../../../BaseController';
import { FragmentNames, ScoreMorseListAliases } from '../../../../codegen';
import { ApplicationRoute } from '../../../../constants/routes';
import { Inject } from '@odinjs/odin';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import InformationBarUtils from '../../../../controllers/commons/header/information-bar-header-utils';
import { ScoreAndIndexesService } from '../../scores-list/scores-list-service';
import { ScoresAndIndexesStatusType } from '../../score-types';

@Controller({ component: ScoreMorseListAliases.LAYOUT_SCORE_MORSE_LIST, fragment: FragmentNames.SCORE_MORSE_LIST })
export default class ScoreMorseListController extends BaseController {

  @Inject(ScoreMorseListAliases.PANEL_GLOBAL_ACTIONS)
  private panelGlobalActions!: PanelAPI;

  @OnMount({ target: ScoreMorseListAliases.PANEL_GLOBAL_ACTIONS })
  handlePanelGlobalActionsMount(): void {
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;
    this.panelGlobalActions.setVisible(allowInfo);
  }

  @OnClick({ target: ScoreMorseListAliases.ADD_SCORE_MORSE_CUSTOM_DYNAMIC_BUTTON })
  handleOnClick(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(
      ApplicationRoute.SCORE_MORSE_CREATE, {
        encounterId,
        patientId,
      }
    )
  }

  @OnClick({ target: ScoreMorseListAliases.DECK_SCORE_MORSE })
  handleOnClickCard(event: ClickEvent): void {
    const { idScoreIndexes, status } = event.value;
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;
    const accessViewer = ((status === ScoresAndIndexesStatusType.ACTIVE) || (!allowInfo))
    const route = accessViewer ? ApplicationRoute.SCORE_MORSE_VIEWER : ApplicationRoute.SCORE_MORSE_EDIT;

    applicationContext.redirect(route, {
      encounterId,
      idScoreIndexes,
      patientId,
    });
  }
}
